import { render, staticRenderFns } from "./AdminPriceSettings.vue?vue&type=template&id=75da8674"
import script from "./AdminPriceSettings.vue?vue&type=script&lang=js"
export * from "./AdminPriceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports